import type { RefObject } from "react";

import IdeaSidebar from "components/ideas/IdeaSidebar/IdeaSidebar";
import type { ItemRefs } from "components/ideas/useIdeaScrollTracking";

import type { IdeaPreviewIdea } from "../types";

type IdeaAssessmentProps = {
  idea: IdeaPreviewIdea;
  assessment?: NonNullable<IdeaPreviewIdea["assessments"]>[number];
  sectionRefs?: RefObject<ItemRefs>;
  fieldRefs?: RefObject<ItemRefs>;
  scrollRef?: RefObject<HTMLDivElement | null>;
};

export const IdeaAssessment = ({
  idea,
  sectionRefs,
  fieldRefs,
  scrollRef,
}: IdeaAssessmentProps) => {
  return (
    <div style={{ display: "flex" }}>
      <IdeaSidebar
        sectionRefs={sectionRefs}
        fieldRefs={fieldRefs}
        scrollRef={scrollRef}
        isEditing={false}
      />
    </div>
  );
};
